import React from "react";
import { X } from "lucide-react";
import { getPostTypeBorderColor } from "../../utils/postTypeUtils";

/**
 * MobilePostTypeFilters - Mobile post type filter buttons component
 * Displays post type filter buttons optimized for mobile view
 */
const MobilePostTypeFilters = ({
	postTypes,
	postTypeFilters,
	togglePostTypeFilter,
	clearPostTypeFilters,
	hasActiveFilters,
}) => {
	return (
		<div className="rounded-lg border-2 border-purple-300 bg-white p-3 shadow-lg dark:border-purple-700 dark:bg-gray-800 lg:hidden">
			<div className="mb-3 flex items-center justify-between">
				<h3 className="text-sm font-bold text-gray-900 dark:text-white">
					Filter Posts
				</h3>
				{hasActiveFilters ? (
					<button
						onClick={clearPostTypeFilters}
						className="text-xs text-purple-600 underline hover:text-purple-700 dark:text-purple-400 dark:hover:text-purple-300"
					>
						Show All
					</button>
				) : null}
			</div>
			<div className="flex flex-wrap justify-center gap-2">
				{postTypes.map((type) => {
					const Icon = type.icon;
					const isFiltered = postTypeFilters[type.id];
					return (
						<button
							key={type.id}
							onClick={() => togglePostTypeFilter(type.id)}
							className={`flex min-w-[90px] flex-1 items-center justify-center gap-1.5 whitespace-nowrap rounded-full border-2 px-3 py-2 transition-colors ${
								isFiltered
									? `${type.color} text-white ${getPostTypeBorderColor(type.id)}`
									: `bg-gray-200 text-gray-900 hover:bg-gray-300 dark:bg-gray-700 dark:text-white dark:hover:bg-gray-600 ${getPostTypeBorderColor(type.id)}`
							}`}
						>
							<Icon size={16} className="flex-shrink-0" />
							<span className="text-sm">{type.label}</span>
							{isFiltered ? (
								<X
									size={14}
									className="ml-1 text-white opacity-80 hover:opacity-100"
									onClick={(e) => {
										e.stopPropagation();
										togglePostTypeFilter(type.id);
									}}
								/>
							) : null}
						</button>
					);
				})}
			</div>
		</div>
	);
};

export default MobilePostTypeFilters;
